// 导航栏操作


/**
 * 修改标题
 * @param {string} title 标题
 */
export function changeTitle(title) {
  document.title = title
}